var Handlebars = require("../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"contacto\">\r\n    <h6>\r\n        Atenci&oacute;n al cliente: desde la Argentina: <strong>5199-4787</strong> | Desde el exterior <a href=\"mailto:accesodigital@lanacion.com.ar\">accesodigital@lanacion.com.ar</a>\r\n    </h6>\r\n    <hr class=\"separador-gris\">\r\n</div>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./Statics/scripts/paywall/views/partials/contacto.hbs
// module id = 517
// module chunks = 0